import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { FulfillmentGroupUpdate } from "@redotech/redo-merchant-fulfillment-rpc/schema/update-fulfillment-groups";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { FulfillmentNotes } from "../../common/notes";

export const NotesCard = memo(function NotesCard({
  fulfillmentGroup,
  updateRows,
  isEditable,
}: {
  fulfillmentGroup: FulfillmentGroupData;
  updateRows: (updates: FulfillmentGroupUpdate[]) => void;
  isEditable: boolean;
}) {
  return (
    <Flex
      bgColor="primary"
      borderColor="secondary"
      borderRadius="lg"
      borderStyle="solid"
      borderWidth="1px"
      dir="column"
      flexDirection="column"
      gap="3xl"
      p="3xl"
      w="full"
    >
      <Text color="secondary" fontSize="sm" fontWeight="medium">
        Notes
      </Text>
      <FulfillmentNotes
        everythingDisabled={!isEditable}
        fulfillmentGroups={[fulfillmentGroup]}
        updateRows={updateRows}
      />
    </Flex>
  );
});
